import React from "react";

import {templates} from "@reactivated";

import {Layout} from "@client/components/Layout";
import { ErrorPage } from "@client/components/ErrorPage";


export const Template = (props: templates.NotFound404) => (
    <Layout title="Not Found">
        <ErrorPage
            title="404 Page Not Found"
            description="Sorry, we couldn't find the page you're looking for."
        ></ErrorPage>
    </Layout>
);
